import { useState } from "react";
import { changePassword } from "../apis/AuthApis";
import { userLogin } from "../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dummyUserProfile from "../assets/dummy-profile-photo.png";
import { editProfile } from "../apis/UserProfile";
import { toast } from "react-toastify";
import { uploadSingleFileImage } from "../apis/UploadImgApis";
export const useProfileHooks = (setPersonalInfoModalOpen) => {
  //change password modal functionalities

  //all redux
  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const user_redux = useSelector((s) => s?.user ?? {});

  //all local states
  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);

  const [passwords, setPasswords] = useState({
    old: "",
    new: "",
    confirm: "",
  });

  //all functions
  const onPressSaveBtn = async () => {
    let payload = {
      oldPassword: passwords?.old,
      newPassword: passwords?.new,
      confirmPassword: passwords?.confirm,
    };
    console.log(payload);

    const res = await changePassword(payload);
    if (res.success) {
      setChangePasswordModalOpen(false);
      dispatch(userLogin(null));
      localStorage.clear();
      navigateTo("/");
    }
  };

  //all profile info popups

  //all local states

  const [personalDetails, setPersonalDetails] = useState({
    firstName: user_redux?.name?.first ?? "",
    lastName: user_redux?.name?.last ?? "",
    profile: user_redux?.profilePicture ?? dummyUserProfile,
    email: user_redux.email ?? "",
    age: "40",
    number: "3205586733",
    countryCode: "+92",
    country: user_redux.address?.country ?? "",
    city: user_redux.address?.city ?? "",
  });

  //all functions

  const onPressPerosnalInfoSaveBtn = () => {
    const isNewFile = personalDetails?.profile instanceof File;

    const handleProfileUpdate = (profileImageUrl) => {
      const payload = {
        name: {
          first: personalDetails?.firstName,
          last: personalDetails?.lastName,
        },
        email: personalDetails?.email,
        age: parseInt(personalDetails?.age),
        address: {
          country: personalDetails?.country,
          city: personalDetails?.city,
        },
        phone: {
          countryCode: personalDetails?.countryCode,
          number: personalDetails?.number,
        },
        profilePicture: profileImageUrl,
      };

      console.log({ payload });

      editProfile(payload).then((res) => {
        dispatch(userLogin(res?.user));
        toast.success("Profile Updated Successfully");
        setPersonalInfoModalOpen(false);
      });
    };

    if (isNewFile) {
      const imgPayload = { file: personalDetails.profile };

      uploadSingleFileImage(imgPayload).then((res) => {
        if (res?.success) {
          handleProfileUpdate(res.data);
        } else {
          toast?.error(res?.data?.message || "Image upload failed");
        }
      });
    } else {
      // Assuming the URL is already valid and doesn't need uploading
      handleProfileUpdate(personalDetails?.profile);
    }
  };

  return {
    //all redux
    user_redux,
    //all local states
    passwords,
    setPasswords,
    changePasswordModalOpen,
    setChangePasswordModalOpen,

    //all functions
    onPressSaveBtn,

    //all profile info popups

    //all local states
    personalDetails,
    setPersonalDetails,

    //all functions
    onPressPerosnalInfoSaveBtn,
  };
};
